let index = require('./routes.json');

window.route = function() {
    let args = Array.prototype.slice.call(arguments);
    let name = args.shift();

    if (index[name] === undefined) {
        console.error('Unknown route:', name, 'please exec npm run dev or check in files route.php');
    } else {
        return '/' + index[name]
            .split('/')
            .map(s => s[0] === '{' ? args.shift() : s)
            .join('/');
    }
};
